import React from 'react'
import Wrapper from '../Wrapper'

const style = {
                  verticalAlign: 'middle'
                , textAlign: 'center'
                }

const Home = (props) => {
  return (
    <Wrapper>
      <div  style={style}>
      Welcome! <br/>
      We've been developing web applications since 1995, so we've got it right.<br/>
      Call us in New York City at: 212.362.6362, or <a href="mailto:sales@cogdata.com">email</a>.
      </div>
    </Wrapper>
 )
}

export default Home



// WEBPACK FOOTER //
// ./src/components/pages/Home.js